import { IconButton, Tooltip } from '@mui/material';
import { IconEdit } from '@nps.today/component-library';
import { useTranslator } from 'translation/useTranslator';

type ToggleEditProps = {
  isEditable: boolean;
  onToggleEditable: () => void;
};
const ToggleEdit = ({ isEditable, onToggleEditable }: ToggleEditProps) => {
  const translator = useTranslator();
  return (
    <Tooltip title={translator.toggleEditable()}>
      <IconButton color={isEditable ? 'primary' : 'default'} onClick={onToggleEditable}>
        <IconEdit />
      </IconButton>
    </Tooltip>
  );
};

export default ToggleEdit;
